

import { LayoutCrearDoc } from "../../layouts"
import { TablaListadoCotizaciones } from "../components";
import { CargandoMedio } from "../../components";
import { useListadoTodasCotizaciones } from "../../../hooks/cache";
import { BuscadorXTermino } from "../../components/buscadores";





export const ListadoTodasCotizaciones = () => {


    const { data, isLoading, page, termino, chagePage, chageTermino } = useListadoTodasCotizaciones();
    

    return (
        <LayoutCrearDoc titulo='Listado Cotizaciones' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de cotizaciones..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="cotización" playhol="nombre de usuario o cedula" />
                <TablaListadoCotizaciones data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>


    )
}
